import L from "../constants/baysportLabels";
import { resolvePlanAccess } from "./planEntitlements";

function getStaffFeatures(options = {}) {
  const { entitlements, tenant, billing } = options;
  const plan = resolvePlanAccess(entitlements, tenant, billing);
  return {
    chat: plan.chat,
    clubLife: plan.clubLife,
    polls: plan.polls,
    fullBranding: plan.fullBranding,
  };
}

function filterStaffNavItem(item, f) {
  switch (item.id) {
    case "chat":
      return f.chat;
    case "life":
      return f.clubLife;
    case "polls":
      return f.polls;
    default:
      return true;
  }
}

/** Главное меню тренера */
export const CORE_STAFF_NAV = [
  { id: "overview", to: "/staff/app", end: true, label: L.summary, icon: "overview" },
  { id: "schedule", to: "/staff/app/schedule", label: L.schedule, icon: "schedule" },
  { id: "chat", to: "/staff/app/chat", label: "Чат", icon: "chat" },
  { id: "clients", to: "/staff/app/clients", label: L.clients, icon: "clients" },
  { id: "journal", to: "/staff/app/journal", label: L.journal, icon: "journal" },
];

export const STAFF_BOTTOM_TABS = [
  ...CORE_STAFF_NAV,
  { id: "more", to: "/staff/app/more", label: "Ещё", icon: "settings" },
];

const CORE_BOTTOM_TAB_IDS = new Set(CORE_STAFF_NAV.map((item) => item.id));

/** Раздел «Ещё» — без финансов, команды и настроек клуба */
export const MORE_STAFF_NAV = [
  { id: "life", to: "/staff/app/life", label: "Клуб", icon: "life" },
  { id: "groups", to: "/staff/app/groups", label: L.groups, icon: "groups" },
  { id: "polls", to: "/staff/app/polls", label: "Опросы", icon: "polls" },
];

export const STAFF_PROFILE_NAV = {
  id: "profile",
  to: "/staff/app/profile",
  label: "Профиль",
  icon: "settings",
};

export function buildStaffSidebarNav(options = {}) {
  const f = getStaffFeatures(options);
  const main = CORE_STAFF_NAV.filter((item) => filterStaffNavItem(item, f));
  const more = MORE_STAFF_NAV.filter((item) => filterStaffNavItem(item, f));
  const bottomTabs = [
    ...main,
    { id: "more", to: "/staff/app/more", label: "Ещё", icon: "settings" },
  ];
  return {
    main,
    more,
    footer: [STAFF_PROFILE_NAV],
    bottomTabs,
  };
}

export function resolveStaffBottomTab(pathname) {
  const tab = resolveStaffTabId(pathname);
  if (CORE_BOTTOM_TAB_IDS.has(tab)) return tab;
  return "more";
}

export function resolveStaffPageTitle(tabId) {
  if (tabId === "overview") return null;
  if (tabId === "more") return "Ещё";
  if (tabId === "notifications") return "Уведомления";
  const all = [...CORE_STAFF_NAV, ...MORE_STAFF_NAV, STAFF_PROFILE_NAV];
  const item = all.find((entry) => entry.id === tabId);
  return item?.label || "Тренер";
}

export function resolveStaffTabId(pathname) {
  const path = pathname.replace(/\/$/, "") || "/staff/app";
  if (path === "/staff/app/more") return "more";
  const ordered = [
    { id: "chat", path: "/staff/app/chat" },
    { id: "clients", path: "/staff/app/clients" },
    { id: "life", path: "/staff/app/life" },
    { id: "polls", path: "/staff/app/polls" },
    { id: "notifications", path: "/staff/app/notifications" },
    { id: "profile", path: "/staff/app/profile" },
    { id: "branding", path: "/staff/app/branding" },
    { id: "schedule", path: "/staff/app/schedule" },
    { id: "journal", path: "/staff/app/journal" },
    { id: "groups", path: "/staff/app/groups" },
    { id: "overview", path: "/staff/app" },
  ];
  const match = ordered.find(
    (t) => path === t.path || (t.path !== "/staff/app" && path.startsWith(`${t.path}/`)),
  );
  return match?.id || "overview";
}

export function staffJournalUrl({ date, sessionId, groupId } = {}) {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  if (sessionId) params.set("session", sessionId);
  if (groupId) params.set("group", groupId);
  const qs = params.toString();
  return qs ? `/staff/app/journal?${qs}` : "/staff/app/journal";
}

export function staffScheduleUrl({
  date,
  sessionId,
  groupId,
  trainerId,
  view = "month",
} = {}) {
  const params = new URLSearchParams();
  params.set("view", view);
  if (date) params.set("date", date);
  if (sessionId) params.set("session", sessionId);
  if (groupId) params.set("group", groupId);
  if (trainerId) params.set("trainer", trainerId);
  return `/staff/app/schedule?${params.toString()}`;
}

export function redirectForStaffRoute(pathname, options = {}) {
  const f = getStaffFeatures(options);
  const path = pathname.replace(/\/$/, "");
  if (
    (path === "/staff/app/chat" || path.startsWith("/staff/app/chat/")) &&
    !f.chat
  ) {
    return "/staff/app";
  }
  if (
    (path === "/staff/app/life" || path.startsWith("/staff/app/life/")) &&
    !f.clubLife
  ) {
    return "/staff/app/more";
  }
  if (
    (path === "/staff/app/polls" || path.startsWith("/staff/app/polls/")) &&
    !f.polls
  ) {
    return "/staff/app/more";
  }
  if (
    (path === "/staff/app/branding" || path.startsWith("/staff/app/branding/")) &&
    !f.fullBranding
  ) {
    return "/staff/app/profile";
  }
  return null;
}
